import { getBasisConfigs, settings } from '@/utils/wechat/weapp/config'
const wx = require('weixin-js-sdk')

export default {
  data: () => ({
    shareLink: undefined
  }),
  mounted () {
    this.shareLink = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}${process.env.VUE_APP_BASE_PATH}${decodeURIComponent(this.$route.fullPath)}`
    const organization = this.$ls.get('org')
    if (organization) {
      getBasisConfigs(this.shareLink).then((config) => {
        const { apiMap } = settings
        wx.config(Object.assign(config, {
          jsApiList: [apiMap.shareOnChat, apiMap.shareOnMoments, apiMap.showMenuItems, apiMap.hideMenuItems], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          openTagList: ['wx-open-launch-weapp']
        }))
        this.shareWx()
      })
    }
  },
  methods: {
    shareWx () {
      const organization = this.$ls.get('org')
      console.log('触发 wx 分享', organization)
      organization.name && (document.title = `${organization.name}`)
      const shareOptions = {
        title: organization.name || '智能书法艺术平台',
        desc: organization.desc || '智能书法艺术平台',
        imgUrl: organization.avatar,
        link: this.shareLink
      }
      wx.ready(function () {
        wx.showMenuItems({
          menuList: [
            'menuItem:share:appMessage',
            'menuItem:share:timeline',
            'menuItem:share:qq',
            'menuItem:share:weiboApp',
            'menuItem:share:QZone'
          ] // 要显示的菜单项，所有menu项见附录3
        })
        wx.updateAppMessageShareData({
          title: shareOptions.title, // 分享标题
          desc: shareOptions.desc, // 分享描述
          link: shareOptions.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareOptions.imgUrl, // 分享图标
          success: function (res) {
            // 设置成功
            if (res) {
              // alert(res.errMsg)
            }
          },
          fail: function (res) {
            // alert(res)
          }
        })
        wx.updateTimelineShareData({
          title: shareOptions.title, // 分享标题
          link: shareOptions.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareOptions.imgUrl, // 分享图标
          success: function () {
            // 设置成功
          }
        })
      })
      wx.error(function (res) {
        // alert(res)
      })
    }
  }
}
